import { Component, Input } from "@angular/core"

@Component({
  selector: 'red-dot',
  template: `
    <small *ngIf="show" class="d-flex align-items-center">
      <i class="fas fa-circle fa-sm"
        [class]="dotColor"
        [tooltip]="tooltipText"
        [placement]="placement"
        containerClass="white-tooltip">
      </i>
    </small>
  `
})
export class RedDot {
  @Input() show: boolean = false;
  @Input() placement: string = "auto";
  @Input() tooltipText: string;
  @Input() dotColor: string = "text-red"
}
